import { error, finish } from '../../../modules/system-settings/actions/get-bog-settings';
import api from '../../../api';

export function request(dispatch) {
    api.get(`/bonus-rules/best-odds-guaranteed`, void 0, { cache: true }).then(
        data => dispatch(finish(data)),
        (errors) => dispatch(error(errors))
    );
}